import { Typography } from "@/modules/theme/components/Typography/Typography";
import { useTheme } from "@/modules/theme/hooks/useTheme";

import { createCommentStyles } from "./createCommentStyles";

type CommentProps = {
  children: string;
};

export const Comment = ({ children }: CommentProps) => {
  const classes = createCommentStyles(useTheme());

  return (
    <div className={classes.root}>
      <div className={classes.comment}>
        <Typography variant="contentSmall" className={classes.text}>
          {children}
        </Typography>
      </div>
    </div>
  );
};
